import { useEffect, useState } from 'react'

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const checkAuth = () => {
    const accessToken =
      typeof window !== 'undefined' ? localStorage.getItem('token-ldx') : null
    setIsAuthenticated(!!accessToken)
  }

  useEffect(() => {
    checkAuth()
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'token-ldx') {
        checkAuth()
      }
    }
    const handleAuthChange = () => {
      checkAuth()
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('storage', handleStorageChange)
      window.addEventListener('auth-changed', handleAuthChange)
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('storage', handleStorageChange)
        window.removeEventListener('auth-changed', handleAuthChange)
      }
    }
  }, [])

  return {
    isAuthenticated,
    checkAuth,
  }
}

export const triggerAuthChange = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('auth-changed'))
  }
}
